import {Button, Grid, MenuItem} from "@mui/material";
import { useParams } from "react-router-dom";
import { IStatusCodes } from "../../api/tenantCommunityInboxPost";

import FormikInput from "../../components/Form/FormikInput";
import FormikSelect from "../../components/Form/FormikSelect";
import Form from "../../components/Templates/Form";
import useTenantCommunityInboxPostContainer from "../../containers/TenantCommunityInbox/useTenantCommunityInboxPostContainer";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { statusesAr } from "../../utils/translations";
import { translator } from "../../utils/translations/translator";
import Info from "../../components/Info";
import ImageList from "../../components/ImageList";
import AlertDialog from "../../components/AlertDialog";

const EditTenantCommunityInboxPost = () => {
  const { postId } = useParams();

  const {
    pageLoading,
    tenantCommunityInboxPostFormik,
    loading,
    postImage,
    handleAttachment,
    handleOpenDeleteImage,
    openDeleteDialog,
    setOpenDeleteDialog,
    handleDeleteImage
  } = useTenantCommunityInboxPostContainer(postId, true);
  const { isRTL } = useRTL();

  const { pages, general } = useContent();
  const { tenantCommunityInbox } = pages;

  const statuses = [
    { value: IStatusCodes.Pending, label: "Pending Review" },
    { value: IStatusCodes.Published, label: "Published" },
    { value: IStatusCodes.Rejected, label: "Rejected by Admin" },
    { value: IStatusCodes.Scheduled, label: "Scheduled" },
  ];

  return (
    <Form
      title={tenantCommunityInbox.tenantCommunityInboxPost}
      pageLoading={pageLoading}
      formik={tenantCommunityInboxPostFormik}
      submitLoading={loading}
      width="75%"
      id={postId}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormikInput
            formik={tenantCommunityInboxPostFormik}
            name="title"
            label={tenantCommunityInbox.title}
          />
        </Grid>

        <Grid item xs={12}>
          <FormikInput
            formik={tenantCommunityInboxPostFormik}
            name="message"
            label={tenantCommunityInbox.message}
            multiline
            rows={3}
          />
        </Grid>

        <Grid item xs={12}>
          <FormikSelect
            formik={tenantCommunityInboxPostFormik}
            name="status"
            label={tenantCommunityInbox.status}
          >
            {statuses.map((status: any) => (
              <MenuItem key={status.value} value={status.value}>
                {isRTL
                  ? translator(status.label, statusesAr)
                  : status.label}
              </MenuItem>
            ))}
          </FormikSelect>
        </Grid>

        <Grid item xs={12}>
          <Info title={tenantCommunityInbox.attachments} />
          <ImageList images={postImage} handleAction={handleOpenDeleteImage} />

          <Button variant="contained" component="label" sx={{ my: 1 }}>
            {tenantCommunityInbox.chooseFile}
            <input
                hidden
                accept="image/*"
                type="file"
                key={postImage}
                onChange={handleAttachment}
            />
          </Button>
        </Grid>
      </Grid>

      <AlertDialog
          open={openDeleteDialog}
          handleClose={() => setOpenDeleteDialog(false)}
          onAgree={handleDeleteImage}
          loading={loading}
          agreeText={general.delete}
          disagreeText={general.cancel}
          title={tenantCommunityInbox.sureDeleteImg}
      />
    </Form>
  );
};

export default EditTenantCommunityInboxPost;
